import React from 'react';
import { Route, Routes } from 'react-router-dom';
import HomePage from '../../pages/HomePage.js';
import RolesPage from '../../pages/RolesPage.js';
import QuestionPage from '../../pages/QuestionPage.js';
import CertificationsPage from '../../pages/CertificationsPage.js';
import RegisterPage from '../../pages/RegisterPage.js';
import UsersListPage from '../../pages/UsersListPage.js';
import LoginPage from '../../pages/LoginPage.js';
import PrivateRoute from '../../pages/PrivateRoute.js';
import ResetPasswordPage from '../../pages/ResetPasswordPage.js';
import ForgotPasswordPage from '../../pages/ForgotPasswordPage.js';
import AdminLoginPage from '../../pages/AdminLoginPage.js';
import AssessmentInfoPage from '../../pages/AssessmentInfoPage.js';

const MyRoutes = ({ setAuthToken, handleAnswerCreate }) => {
    return (
            <Routes>
                <Route path="/login" element={<LoginPage setAuthToken={setAuthToken} />} />
                <Route path="/admin-login" element={<AdminLoginPage setAuthToken={setAuthToken} />} />
                <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />

                <Route
                    path="/:userId"
                    element={<PrivateRoute element={<HomePage />} deny={['Admin']} />}
                />

                <Route
                    path="/assessment-info/:userId/:application"
                    element={<PrivateRoute element={<AssessmentInfoPage />} deny={['Admin']} />}
                />

                <Route
                    path="/test/:userId/:application"
                    element={<PrivateRoute element={<QuestionPage handleAnswerCreate={handleAnswerCreate} />} deny={['Admin']} />}
                />

                <Route
                    path="/select-role"
                    element={
                        <PrivateRoute
                            element={<RolesPage />}
                            allow={['Unassigned']}
                        />
                    }
                />

                <Route
                    path="/select-certifications"
                    element={
                        <PrivateRoute
                            element={<CertificationsPage />}
                            allow={['Unassigned']}
                        />
                    }
                />

                <Route
                    path="/register/:client"
                    element={
                        <PrivateRoute
                            element={<RegisterPage />}
                            allow={['Admin']}
                        />
                    }
                />

                <Route
                    path="/registeredUsers/:client"
                    element={
                        <PrivateRoute
                            element={<UsersListPage />}
                            allow={['Admin']}
                        />
                    }
                />
            </Routes>
    );
};

export default MyRoutes;